import { OmniViewMode } from '../omnidashboard.config';
import { ChapterInfo } from '../omnidashboard.models';
import { FiscalYearOption } from './omnidashboard-fiscal-year';
import { OmniFilterState } from '../filters/omnidashboard-filters.model';
import { OmniMatrixViewModel } from '../matrix/omnidashboard-matrix-view';
import { createEmptyMatrixViewModel } from '../matrix/omnidashboard-matrix-view';
import { DEFAULT_OMNI_VIEW } from '../metrics/metric-registry';

export interface OmnidashboardErrors {
  hasTimeoutError: boolean;
  hasApiError: boolean;
}

export interface OmnidashboardState {
  activeView: OmniViewMode;
  selectedFiscalYear: string;
  fiscalYearOptions: FiscalYearOption[];
  chapters: ChapterInfo[];
  filters: OmniFilterState;
  matrix: OmniMatrixViewModel;
  isLoading: boolean;
  isMetricLoading: boolean;
  isEmptyResult: boolean;
  errors: OmnidashboardErrors;
  loadedMetrics: Set<OmniViewMode>;
  filterAnnounceMessage: string;
  siteFilterTooltip: string;
  ergFilterTooltip: string;
}

export function createInitialOmnidashboardState(
  fiscalYearOptions: FiscalYearOption[],
  selectedFiscalYear: string
): OmnidashboardState {
  return {
    activeView: DEFAULT_OMNI_VIEW,
    selectedFiscalYear,
    fiscalYearOptions,
    chapters: [],
    filters: { selectedSiteNames: [], selectedErgNames: [] },
    matrix: createEmptyMatrixViewModel(),
    isLoading: false,
    isMetricLoading: false,
    isEmptyResult: false,
    errors: { hasTimeoutError: false, hasApiError: false },
    // chapter-status is populated during matrix build; other views are lazy-loaded.
    loadedMetrics: new Set<OmniViewMode>([DEFAULT_OMNI_VIEW]),
    filterAnnounceMessage: '',
    siteFilterTooltip: '',
    ergFilterTooltip: '',
  };
}
